import ServiceGraphQL from 'src/service/gql-service';
import { addPaymentMethod } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const AddPaymentMethod = (data) => {
  const params = {
    query: addPaymentMethod.QUERY,
    variables: {
      record: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
